module.exports = __webpack_public_path__ + "img/sph.bf23a046.png";